/* CUSTOM JOKER: barre « Ajouter au panier » flottante en mobile / Impulse 9.2 n'offre pas cette option, plan §4 / 2026-09-01 — et, en fin de fichier, la récompense du panier / Phase 4 §3.3 / 2026-09-05 */

/*
  JavaScript du chantier, deux blocs indépendants, aucune bibliothèque,
  aucune dépendance. Bloc 1 : la barre flottante. Bloc 2 (en fin de fichier) :
  la récompense du panier.

  Comportement : sur les petits écrans, dès que le vrai bouton d'ajout au panier
  sort du champ de vision, une barre compacte apparaît en bas de l'écran. Elle
  ne duplique pas le formulaire : son bouton déclenche celui de la page, ce qui
  garde une seule source de vérité pour la variante choisie et les validations.

  La barre est en `hidden` dans le HTML : sans JavaScript, elle n'existe pas et
  la page fonctionne exactement comme avant.
*/
(function () {
  'use strict';

  var LARGEUR_MOBILE = 768;

  function init() {
    var barre = document.querySelector('[data-joker-atc]');
    var bloc = document.querySelector('.product-block--buy-buttons');
    if (!barre || !bloc) return;

    var vraiBouton = bloc.querySelector('.add-to-cart, button[type="submit"]');
    if (!vraiBouton) return;

    var bouton = barre.querySelector('[data-joker-atc-btn]');
    var prix = barre.querySelector('[data-joker-atc-prix]');

    // Le bouton de la barre relaie celui de la page.
    bouton.addEventListener('click', function () {
      vraiBouton.click();
    });

    // Le prix suit les changements de variante d'Impulse.
    var sourcePrix = document.querySelector('.product-block--price [data-product-price], .product__price');
    if (sourcePrix && window.MutationObserver) {
      new MutationObserver(function () {
        prix.textContent = sourcePrix.textContent.trim();
      }).observe(sourcePrix, { childList: true, characterData: true, subtree: true });
    }

    function surEcranMobile() {
      return window.innerWidth <= LARGEUR_MOBILE;
    }

    function afficher(oui) {
      barre.hidden = !(oui && surEcranMobile());
    }

    if (!('IntersectionObserver' in window)) return;

    new IntersectionObserver(
      function (entrees) {
        // Visible tant que le vrai bouton est hors champ, et seulement
        // vers le bas : inutile de couvrir l'écran avant de l'avoir atteint.
        var e = entrees[0];
        afficher(!e.isIntersecting && e.boundingClientRect.top < 0);
      },
      { threshold: 0 }
    ).observe(vraiBouton);

    window.addEventListener('resize', function () {
      if (!surEcranMobile()) barre.hidden = true;
    });
  }

  /*
    Fermeture du bandeau Jeux Dépôt (§3.6), quand le réglage est activé.
    La mémoire est indispensable : sans elle, le bandeau reviendrait à chaque
    page et la croix serait plus agaçante qu'utile.
  */
  var CLE_BANDEAU = 'joker-bandeau-ferme';

  function initBandeau() {
    var bandeau = document.querySelector('[data-joker-bandeau]');
    if (!bandeau) return;

    var bouton = bandeau.querySelector('[data-joker-bandeau-fermer]');
    if (!bouton) return;

    try {
      if (localStorage.getItem(CLE_BANDEAU) === '1') {
        bandeau.hidden = true;
        return;
      }
    } catch (e) {
      // Navigation privée ou stockage refusé : le bandeau reste visible.
    }

    bouton.addEventListener('click', function () {
      bandeau.hidden = true;
      try {
        localStorage.setItem(CLE_BANDEAU, '1');
      } catch (e) {
        // Sans stockage, la fermeture ne vaut que pour cette page.
      }
    });
  }

  /*
    Filtre par région de la page des points de dépôt (§3.3).
    Les régions viennent des données, pas d'une liste écrite : le CSS d'une
    section n'étant pas interprété par Liquid, un filtre en CSS pur devrait
    connaître les régions à l'avance. D'où ces quelques lignes.

    Les boutons sont en `hidden` dans le HTML et révélés ici : sans JavaScript,
    la liste complète s'affiche et aucun contrôle mort ne traîne.
  */
  function initFiltreDepots() {
    var racine = document.querySelector('[data-joker-depots-filtre]');
    if (!racine) return;

    var groupe = racine.querySelector('[data-joker-depots-boutons]');
    var liste = racine.querySelector('[data-joker-depots-liste]');
    if (!groupe || !liste) return;

    var cartes = liste.querySelectorAll('[data-region]');
    var vide = racine.querySelector('[data-joker-depots-vide]');
    groupe.hidden = false;

    groupe.addEventListener('click', function (e) {
      var bouton = e.target.closest('[data-region]');
      if (!bouton || !groupe.contains(bouton)) return;

      var region = bouton.getAttribute('data-region');
      var visibles = 0;

      Array.prototype.forEach.call(groupe.querySelectorAll('[data-region]'), function (b) {
        b.classList.toggle('is-actif', b === bouton);
      });

      Array.prototype.forEach.call(cartes, function (carte) {
        var garde = !region || carte.getAttribute('data-region') === region;
        carte.hidden = !garde;
        if (garde) visibles++;
      });

      if (vide) vide.hidden = visibles > 0;
    });
  }

  /*
    « + Panier » des cartes produit (§2.8).

    Le formulaire fonctionne sans JavaScript : Shopify ajoute au panier et
    redirige vers /cart. Ces lignes évitent la redirection et ouvrent le tiroir,
    en s'appuyant sur `cart:build` et `cart:open` — deux événements que le thème
    écoute lui-même et décrit comme le moyen prévu de reconstruire le panier.
    Aucune fonction interne d'Impulse n'est appelée.

    Un seul écouteur, posé sur le document : les cartes se comptent par
    dizaines sur une page de collection, et la grille est re-rendue par les
    filtres. Un écouteur par formulaire serait à reposer à chaque fois.
  */
  function initQuickAdd() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-joker-quick-add]');
      if (!form) return;

      e.preventDefault();

      var bouton = form.querySelector('button[type="submit"]');
      if (bouton) bouton.disabled = true;

      fetch(form.action + '.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      })
        .then(function (r) {
          if (!r.ok) throw new Error('ajout refusé');
          document.dispatchEvent(new CustomEvent('cart:build'));
          document.dispatchEvent(new CustomEvent('cart:open'));
        })
        .catch(function () {
          // Rupture de stock signalée entre-temps, réseau coupé : on laisse
          // Shopify répondre lui-même plutôt que d'inventer un message.
          form.submit();
        })
        .then(function () {
          if (bouton) bouton.disabled = false;
        });
    });
  }

  function demarrer() {
    init();
    initBandeau();
    initFiltreDepots();
    initQuickAdd();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();

/* CUSTOM JOKER: récompense du panier — retrait automatique du cadeau sous le seuil, choix et changement du cadeau / Phase 4, brief §3.3 / 2026-09-05 */

/*
  La barre et la liste des cadeaux sont en Liquid, re-rendues par Impulse à
  chaque changement du panier (templates/cart.ajax.liquid). Ce bloc ne fait
  que trois choses :
    1. après chaque re-rendu, si le Liquid dit « sous le seuil » et qu'une
       ligne _cadeau existe : la retirer, et le dire ;
    2. « Choisir ce cadeau » : ajouter la variante, quantité 1, _cadeau = "1" ;
    3. « Changer » : retirer la ligne cadeau.
  Chaque action se termine par l'événement cart:build, qu'Impulse écoute pour
  reconstruire le tiroir. Rien ici ne touche à theme.js.

  La configuration (seuil, routes, texte) vient du DOM, posée par Liquid dans
  snippets/cart-drawer.liquid : tant que joker_reward_progress_enable est
  éteint, l'élément n'existe pas et ce bloc s'arrête à la première ligne.
*/
(function () {
  'use strict';

  var avis = document.querySelector('[data-joker-recompense-avis]');
  if (!avis) return;

  var seuil = parseInt(avis.getAttribute('data-seuil'), 10);
  var routes = {
    change: avis.getAttribute('data-route-change'),
    add: avis.getAttribute('data-route-add'),
    update: avis.getAttribute('data-route-update'),
    cart: avis.getAttribute('data-route-cart')
  };
  if (!seuil || !routes.change || !routes.add || !routes.update || !routes.cart) return;

  // Le choix « livraison » est un attribut de panier, jamais une ligne
  // produit : recompense = "livraison". Chaîne vide = attribut effacé.
  var ATTRIBUT = 'recompense';
  var LIVRAISON = 'livraison';

  var enCours = false;

  function appel(url, corps) {
    return fetch(url, {
      method: corps ? 'POST' : 'GET',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: corps ? JSON.stringify(corps) : undefined
    }).then(function (reponse) { return reponse.json(); });
  }

  function lirePanier() {
    return appel(routes.cart + '.js?t=' + Date.now());
  }

  // Le fragment /cart?view=ajax, tel que le tiroir le demande à Impulse.
  function lireFragment() {
    return fetch(routes.cart + '?view=ajax&t=' + Date.now(), { credentials: 'same-origin' })
      .then(function (reponse) { return reponse.text(); });
  }

  function reconstruire() {
    document.dispatchEvent(new CustomEvent('cart:build'));
  }

  function estCadeau(item) {
    return !!(item.properties && item.properties._cadeau === '1');
  }

  // Les lignes _cadeau du panier (JSON) — pour ne jamais en ajouter deux.
  function analyser(cart) {
    return { cadeaux: (cart.items || []).filter(estCadeau) };
  }

  function retirer(item) {
    return appel(routes.change, { id: item.key, quantity: 0 });
  }

  function retirerTous(items) {
    return items.reduce(function (chaine, item) {
      return chaine.then(function () { return retirer(item); });
    }, Promise.resolve());
  }

  function poserChoix(valeur) {
    var attributs = {};
    attributs[ATTRIBUT] = valeur;
    return appel(routes.update, { attributes: attributs });
  }

  // 1. La ceinture côté tiroir : sous le seuil, plus de cadeau ni de choix.
  //    La vérité vient du Liquid : à chaque re-rendu de [data-products] par
  //    Impulse, le bloc [data-joker-recompense] porte « sous le seuil », les
  //    clés des lignes _cadeau et le choix livraison. Rien n'est recalculé ici
  //    (le JSON du panier ne connaît pas la balise « Cadeau », le Liquid oui).
  //    Seules les lignes _cadeau sont retirées : un jeu balisé mis au panier
  //    volontairement appartient au client.
  function verifier(zone) {
    if (enCours) return;
    var bloc = zone.querySelector('[data-joker-recompense]');
    if (!bloc) return;
    // Base du seuil lue une seule fois, pour le retrait ET pour le pop-up.
    var base = parseInt(bloc.getAttribute('data-base-cents'), 10);
    var baseAvant = derniereBase;
    derniereBase = base;
    tenterPopup(baseAvant, base, bloc);
    if (bloc.getAttribute('data-sous-seuil') !== '1') return;
    var cles = (bloc.getAttribute('data-cadeaux') || '').split(',').filter(Boolean);
    var aChoix = bloc.getAttribute('data-livraison') === '1';
    if (!cles.length && !aChoix) return;
    enCours = true;
    retirerTous(cles.map(function (key) { return { key: key }; }))
      .then(function () { return aChoix ? poserChoix('') : null; })
      .then(function () {
        if (cles.length) {
          avis.textContent = avis.getAttribute('data-texte-retire');
          avis.hidden = false;
        }
        reconstruire();
      })
      .catch(function () {})
      .then(function () { enCours = false; });
  }

  // 4. Pop-up au franchissement du seuil (brief pop-up §2). Une fois par
  //    session, jamais au chargement (la première base observée ne compte
  //    que comme « avant »), jamais sur la page panier, jamais avec un cadeau.
  //    Le contenu vient de [data-reward-popup-source] dans la réponse
  //    /cart?view=ajax ; les tuiles sont les mêmes que dans le tiroir, le
  //    même gestionnaire de clic les sert.
  var popup = document.querySelector('[data-joker-popup]');
  var CLE_POPUP = 'jokerRewardPopup';
  var derniereBase = null;
  var origineFocus = null;

  function popupDejaVu() {
    try { return sessionStorage.getItem(CLE_POPUP) === '1'; } catch (e) { return false; }
  }

  function marquerPopup() {
    try { sessionStorage.setItem(CLE_POPUP, '1'); } catch (e) { /* navigation privée : il pourra se rouvrir */ }
  }

  function popupOuvert() {
    return !!popup && (popup.open || popup.classList.contains('joker-reward-popup--repli'));
  }

  function fermerPopup() {
    if (!popupOuvert()) return;
    if (popup.open && typeof popup.close === 'function') {
      popup.close();
    } else {
      popup.classList.remove('joker-reward-popup--repli');
      popup.hidden = true;
      rendreFocus();
    }
  }

  function rendreFocus() {
    if (origineFocus && typeof origineFocus.focus === 'function') origineFocus.focus();
    origineFocus = null;
  }

  function ouvrirPopup(html) {
    popup.querySelector('[data-reward-popup-content]').innerHTML = html;
    origineFocus = document.activeElement;
    marquerPopup();
    popup.hidden = false;
    if (typeof popup.showModal === 'function') {
      popup.showModal();
    } else {
      popup.classList.add('joker-reward-popup--repli');
    }
    var fermer = popup.querySelector('[data-joker-popup-fermer]');
    if (fermer) fermer.focus();
  }

  function tenterPopup(baseAvant, baseApres, bloc) {
    if (!popup || baseAvant === null || isNaN(baseApres)) return;
    if (!(baseAvant < seuil && baseApres >= seuil)) return;
    if (bloc.getAttribute('data-cadeaux')) return;
    if (popupOuvert() || popupDejaVu() || document.body.classList.contains('template-cart')) return;
    lireFragment()
      .then(function (texte) {
        var doc = new DOMParser().parseFromString(texte, 'text/html');
        var source = doc.querySelector('[data-reward-popup-source]');
        if (!source || popupOuvert() || popupDejaVu()) return;
        ouvrirPopup(source.innerHTML);
      })
      .catch(function () {});
  }

  if (popup) {
    popup.addEventListener('close', rendreFocus);
    popup.addEventListener('click', function (evt) {
      // Le voile : un clic sur le <dialog> lui-même, hors du panneau.
      if (evt.target === popup) fermerPopup();
    });
    document.addEventListener('click', function (evt) {
      if (evt.target.closest('[data-joker-popup-fermer]')) fermerPopup();
    });
  }

  var zones = document.querySelectorAll('[data-products]');
  Array.prototype.forEach.call(zones, function (zone) {
    new MutationObserver(function () { verifier(zone); }).observe(zone, { childList: true });
    verifier(zone);
  });

  // 2 et 3. Par délégation : le tiroir est reconstruit à chaque changement.
  //   choisir un jeu      : ajoute la ligne _cadeau, efface l'attribut
  //   choisir la livraison : retire toute ligne _cadeau, pose l'attribut
  //   changer             : retire la ligne cadeau, ou efface l'attribut
  document.addEventListener('click', function (evt) {
    var choisir = evt.target.closest('[data-joker-cadeau-choisir]');
    var changer = evt.target.closest('[data-joker-cadeau-retirer]');
    var livraison = evt.target.closest('[data-joker-livraison-choisir]');
    var livraisonRetirer = evt.target.closest('[data-joker-livraison-retirer]');
    var bouton = choisir || changer || livraison || livraisonRetirer;
    if (!bouton) return;
    evt.preventDefault();
    if (enCours) return;
    enCours = true;
    avis.hidden = true;
    bouton.disabled = true;

    var action;
    if (choisir) {
      // Jamais deux cadeaux : le panier est relu avant d'ajouter.
      action = lirePanier().then(function (cart) {
        if (analyser(cart).cadeaux.length) return null;
        return appel(routes.add, {
          items: [{
            id: parseInt(choisir.getAttribute('data-joker-cadeau-choisir'), 10),
            quantity: 1,
            properties: { _cadeau: '1' }
          }]
        }).then(function () { return poserChoix(''); });
      });
    } else if (livraison) {
      action = lirePanier().then(function (cart) {
        return retirerTous(analyser(cart).cadeaux);
      }).then(function () { return poserChoix(LIVRAISON); });
    } else if (livraisonRetirer) {
      action = poserChoix('');
    } else {
      action = appel(routes.change, {
        id: changer.getAttribute('data-joker-cadeau-retirer'),
        quantity: 0
      });
    }

    // Depuis le pop-up : même ajout, puis le pop-up se ferme et le tiroir
    // s'ouvre, comme après un ajout depuis une fiche.
    var depuisPopup = !!bouton.closest('[data-joker-popup]');

    action.catch(function () {}).then(function () {
      enCours = false;
      bouton.disabled = false;
      if (depuisPopup) fermerPopup();
      reconstruire();
      if (depuisPopup) document.dispatchEvent(new CustomEvent('cart:open'));
      // Shopify applique la réduction automatique avec un court délai : un
      // second re-rendu affiche la ligne cadeau à 0 $ sans attendre un geste.
      window.setTimeout(reconstruire, 2500);
    });
  });
})();
